import type { CreateParkingTicketResponse } from './response-types';
import type {
  BulletinBoard,
  LicensePlate,
  Parkinglot,
  ParkingRecordBill,
} from '@autopass-web/types';

const KEY_PARKINGLOT_SUPPORT_VEHICLE_TYPE =
  'aps_parkinglot_support_vehicle_type';
const KEY_PLATE_NUMBER_FUZZY = 'aps_plate_number_fuzzy';
const KEY_VEHICLE_TYPE = 'aps_vehicle_type';
const KEY_PARKINGLOT_SEARCH_RESULT = 'aps_parkinglot_search_result';
const KEY_SELECTED_PLATE_NUMBER_INFO = 'SELECTED_PLATE_NUMBER_INFO';
const KEY_TICKET_DATA = 'aps_ticket_data';
const KEY_APS_PARTNER = 'aps_partner';

const KEY_PARKINGLOT = 'aps_parkinglot';

class LocalStorageController {
  // Deprecated
  saveParkinglotSupportVehicleType = (obj) =>
    localStorage.setItem(
      KEY_PARKINGLOT_SUPPORT_VEHICLE_TYPE,
      JSON.stringify(obj),
    );
  getParkinglotSupportVehicleType = () =>
    this.getCache(KEY_PARKINGLOT_SUPPORT_VEHICLE_TYPE);

  savePlateNumberFuzzy = (plateNumberFuzzy: string) =>
    localStorage.setItem(KEY_PLATE_NUMBER_FUZZY, plateNumberFuzzy);
  getPlateNumberFuzzy = () =>
    localStorage.getItem(KEY_PLATE_NUMBER_FUZZY) as string | undefined;

  private getCache = (key: string) => {
    const local = localStorage.getItem(key);
    return local == null ? undefined : JSON.parse(local);
  };
}

class SessionStorageController {
  /**
   * New Controller
   */
  saveParkinglot = (obj: Parkinglot) =>
    sessionStorage.setItem(KEY_PARKINGLOT, JSON.stringify(obj));
  getParkinglot = () => this.getCache(KEY_PARKINGLOT) as Parkinglot | null;

  saveApsPartner = (obj: BulletinBoard) =>
    sessionStorage.setItem(KEY_APS_PARTNER, JSON.stringify(obj));
  getApsPartner = () => this.getCache(KEY_APS_PARTNER) as BulletinBoard | null;

  saveSelectedParkingBill = (obj: ParkingRecordBill) =>
    sessionStorage.setItem(KEY_SELECTED_PLATE_NUMBER_INFO, JSON.stringify(obj));
  getSelectedParkingBill = () =>
    this.getCache(KEY_SELECTED_PLATE_NUMBER_INFO) as ParkingRecordBill;

  saveVehicleType = (obj) => localStorage.setItem(KEY_VEHICLE_TYPE, obj);
  getVehicleType = () =>
    localStorage.getItem(KEY_VEHICLE_TYPE) as
      | LicensePlate['vehicle_type']
      | null;

  savePlateNumberSearchResult = (obj) =>
    sessionStorage.setItem(KEY_PARKINGLOT_SEARCH_RESULT, JSON.stringify(obj));
  getPlateNumberSearchResult = () =>
    this.getCache(KEY_PARKINGLOT_SEARCH_RESULT) as ParkingRecordBill[];

  saveTicketData = (obj: CreateParkingTicketResponse) =>
    sessionStorage.setItem(KEY_TICKET_DATA, JSON.stringify(obj));
  getTicketData = () => this.getCache(KEY_TICKET_DATA);

  private getCache = (key) => {
    const local = sessionStorage.getItem(key);
    return local == null ? undefined : JSON.parse(local);
  };
}

const localStorageController = new LocalStorageController();
const sessionStorageController = new SessionStorageController();

export { localStorageController, sessionStorageController };
